import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as ConfigurationActions from "../store/configurationService/actions";
import { ApplicationState } from "../store";

export default function Services() {
    const dispatch = useDispatch();
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12">
                    <h1 className="title-page">Services</h1>
                </div>
            </div>

            <div className="row">
                <div className="col-xs-12 col-sm-8">
                    <div className="box">content</div>
                </div>
                <div className="col-xs-12 col-sm-4">
                    <div className="box">content</div>
                </div>
            </div>
        </React.Fragment>
    );
}
